import { Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import AntTable from "../../AntTable/AntTable";
import SalesRowData from "../../AntTable/tableRowsData/SalesRowData";
import HeadTableSales from "../../GlobalTable/HeadTableSales";
import SubInfo from "../../admin/common/SubInfo";
import Empty from "../../common/Empty";

type Props = {
  data: any;
  isLoading: any;
  page: any;
  setPage: any;
  handelChangeDates: any;
  dateRange: any;
  searchSales: any;
  setSearchSales: any;
  filterType: any;
  setIsFilter: any;
};

const TabReservations = ({
  data,
  isLoading,
  page,
  setPage,
  handelChangeDates,
  dateRange,
  searchSales,
  setSearchSales,
  filterType,
  setIsFilter,
}: Props) => {
  const intl = useIntl();
  const { locale } = useIntl();
  const getStatusStyles = (status: any) => {
    let color = ""; // Define an empty color variable

    switch (status.trim()) {
      case "تمت":
      case "Done":
      case "completed":
        color = "#479821"; // Color for "تمت"
        break;
      case "تم الانشاء":
      case "created":
        color = "#00086D"; // Color for "تم الانشاء"
        break;
      case "جاريه":
      case "pending":
        color = "#CF953D"; // Color for "جاريه"
        break;
      case "canceled":
        color = "#c43535"; // Color for "canceled"
        break;
      default:
        color = "#00086D"; // Default color if status doesn't match any case
        break;
    }

    return { color }; // Return an object with the color property
  };

  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full py-1 flex items-center justify-center">
          {intl.formatMessage({
            id: "sales",
          })}
        </div>
      ),
      dataIndex: "sales",
      render: (text, record) => {
        const style = getStatusStyles(record.status); // Get styles based on status
        return (
          <div
            className={`min-w-[150px]`}
            style={{
              borderTop: `1px ${style.color} solid`,
              borderLeft: locale === "en" ? `1px ${style.color} solid` : "",
              borderRight: locale === "ar" ? `1px ${style.color} solid` : "",
              borderRadius: locale === "ar" ? "0 8px 0 0" : "8px 0px 0 0",
            }}
          >
            #{record?.id}
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full py-1 flex items-center justify-center">
          {intl.formatMessage({
            id: "status",
          })}
        </div>
      ),
      dataIndex: "status",
      // responsive: ["lg"],

      render: (text, record) => {
        const style = getStatusStyles(record.status); // Get styles based on status

        return (
          <div
            className={`cursor-pointer min-w-[150px] py-[0.8rem] bg-white border-solid border-[${style.color}] flex items-center w-full h-full justify-center text-color-primary text-sm font-medium`}
            style={{
              paddingBottom: "10px",
              borderRight: "0px",
              borderLeft: "0px",
              borderBottom: "0px",
              borderTop: `1px ${style.color} solid`,
            }}
          >
            <div
              className={`border-[1px] mb-[3px] flex items-center gap-1 text-center justify-center px-3 rounded-md w-fit min-w-[120px] min-h-[25px] `}
              style={{
                border: `solid ${style.color} 1px`,
                borderTop: `1px ${style.color} solid`,
                color: style.color,
              }}
            >
              <div
                className={`w-[6px] h-[6px] rounded-full`}
                style={{
                  background: style.color,
                  borderTop: `1px ${style.color} solid`,
                }}
              />
              <span className="capitalize">{record?.status}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full py-1 flex items-center justify-center">
          {intl.formatMessage({
            id: "date",
          })}
        </div>
      ),
      // responsive: ["lg"],

      dataIndex: "Date",
      render: (text, record) => {
        const style = getStatusStyles(record.status); // Get styles based on status
        return (
          <div
            style={{ ...style, borderTop: `1px ${style.color} solid` }}
            className={`cursor-pointer py-4 min-w-[150px] !pt-[15px] bg-white border-solid border-[${style.color}] border-t-[1px] border-b-0 border-r-0 border-l-0 w-full text-[#9999A7] text-sm font-medium`}
          >
            <span className="text-[#4F5062] mx-1 font-semibold">
              {dayjs(record?.created_at).format("DD-MM-YYYY HH:mm")}
            </span>
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full py-1 flex items-center justify-center text-center">
          {intl.formatMessage({
            id: "client",
          })}
        </div>
      ),
      dataIndex: "Client",
      render: (text, record) => {
        const style = getStatusStyles(record.status); // Get styles based on status
        console.log(record);
        return (
          <div
            className={`cursor-pointer py-[15px] min-w-[150px] text-[#9999A7] border-solid border-[${style.color}] border-b-0 border-r-0 border-l-0 bg-white w-full`}
            style={{ borderTop: `1px  solid ${style.color}` }}
          >
            <span className="text-[#4F5062] text-sm font-medium capitalize">
              {(record?.client_profile?.first_name ||
                record?.appointmentable?.first_name ||
                record?.appointmentable?.name) +
                " " +
                (record?.client_profile?.last_name ||
                  record?.appointmentable?.last_name ||
                  "")}
            </span>
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] border-b-0 w-full h-full py-1 flex items-center justify-center text-center">
          {intl.formatMessage({
            id: "price",
          })}
        </div>
      ),
      dataIndex: "price",
      render: (text, record) => {
        const style = getStatusStyles(record.status); // Get styles based on status

        return (
          <div
            className={`min-w-[150px]`}
            style={{
              borderTop: `1px ${style.color} solid`,
              borderLeft: locale === "ar" ? `1px ${style.color} solid` : "",
              borderRight: locale === "en" ? `1px ${style.color} solid` : "",
              borderRadius: locale === "en" ? "0 8px 0 0" : "8px 0px 0 0",
            }}
          >
            <SubInfo
              value={+record?.pay}
              label={intl.formatMessage({
                id: "SARshort",
              })}
            />
          </div>
        );
      },
    },
  ];

  const { formatMessage } = useIntl();
  const title = formatMessage({ id: "reservationTitle" });
  return (
    <div className="taps ">
      <HeadTableSales
        setSearchClient={setSearchSales}
        handelChangeDates={handelChangeDates}
        searchClient={searchSales}
        dateRange={dateRange}
        filterType={filterType}
        setIsFilter={setIsFilter}
        data={data || []}
        title={title}
      />

      {isLoading ? (
        <Spin
          size="large"
          className="flex items-center justify-center min-h-[50vh]"
        />
      ) : data?.length > 0 ? (
        <AntTable
          tableColumns={columns}
          tableData={data || []}
          isLoading={isLoading}
          hideArrowExpand
          setPage={setPage}
          page={page}
          total={data?.meta?.total}
          rowData={(record: any) => <SalesRowData record={record} />}
        />
      ) : (
        <div className="mt-6">
          <Empty
            title={intl.formatMessage({ id: "intl.form.noBookingsTitle" })}
            subTitle={intl.formatMessage({
              id: "intl.form.noBookingsSubTitle",
            })}
          />
        </div>
      )}
    </div>
  );
};

export default TabReservations;
